// Shared class names for the Noetivra demo workspaces.

export const focusRing =
  'focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lavender'

export const glassPanel = 'rounded-2xl border border-white/80 bg-white/75 backdrop-blur-md shadow-premium'

export const fieldClass =
  'mt-1.5 w-full rounded-lg border border-line bg-white px-3 py-2.5 text-ink-dark focus:border-lavender focus:outline-none focus:ring-2 focus:ring-lavender/20 aria-[invalid=true]:border-rose-400 disabled:bg-surface-muted disabled:text-ink-muted'

export const labelClass = 'block text-sm font-semibold text-ink-dark'

export const errorClass = 'mt-1.5 text-sm text-rose-700'

export const primaryButton = `inline-flex items-center justify-center gap-2 rounded-md bg-navy px-5 py-2.5 font-semibold text-white hover:bg-navy-light disabled:cursor-not-allowed disabled:opacity-50 transition-colors duration-150 whitespace-nowrap ${focusRing}`

export const secondaryButton = `inline-flex items-center justify-center gap-2 rounded-md border border-line bg-white px-4 py-2.5 font-semibold text-navy hover:bg-surface-muted disabled:cursor-not-allowed disabled:opacity-50 transition-colors duration-150 whitespace-nowrap ${focusRing}`

export const linkButton = `inline-flex items-center gap-1 text-sm font-semibold text-navy hover:text-navy-light transition-colors duration-150 ${focusRing}`

export const passageClass = 'border-l-4 pl-4 font-serif text-[1.05rem] leading-relaxed text-ink-dark'
